import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { getCurrentWebsiteCountry } from "@MasterBluePrint/Services/CurrentWebsiteCountryService";

addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.apiParameter.expand) {
        props.apiParameter.expand = ["warehouses","properties"];
        return;
    }

    if (props.apiParameter.expand.indexOf("properties") === -1) {
        props.apiParameter.expand = [...props.apiParameter.expand,"warehouses", "properties"];
    }
});

addToChainAfter(chain, RequestDataFromApi, async props => {
    await getCurrentWebsiteCountry().then(response =>{
        props.apiResult.currentWebsiteCountry = response;
    });
});